// extracted by mini-css-extract-plugin
export default {"table":"style_table__kI3y9","table-title":"style_table-title__2s58l","table-header":"style_table-header__jqywv","table-row":"style_table-row__VJHnE"};